import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Add, Remove } from './icons';
import { getCurrentLocale } from '../services/api';

const TreatmentDetailsSection: React.FC = () => {
  const locale = getCurrentLocale();
  const isArabic = locale === 'ar';
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const content = {
    title: isArabic ? 'تدابير الوقاية والرعاية اللاحقة' : 'Voorzorgs- en nazorgsmaatregelen',
    treatmentDifferences: {
      title: isArabic ? 'ما هو الفرق بين العلاج 1 و 2 و 3؟' : 'Wat is het verschil tussen behandeling 1, 2 en 3?',
      content: isArabic ? [
        'في كل من علاج الببتيدات للشعر (العلاج 1) وعلاج حشو الشعر (العلاج 3) نستخدم الببتيدات الحيوية المحاكية. الفرق يكمن في الإضافات في علاج حشو الشعر، مثل حمض الهيالورونيك والحديد، التي توفر ترطيبًا مكثفًا ومرونة لفروة الرأس.',
        'هذا يعزز عمل الببتيدات ويعمل كمقوي قوي ضد تساقط الشعر، خاصة في حالات التوتر والتغيرات الهرمونية.',
        'في علاج الإكسوسوم للشعر (العلاج 2) يكون التركيز على الإكسوسومات. هذه المكونات المبتكرة تقلل وتبطئ تساقط الشعر ويمكنها حتى إيقافه في مشاكل الثعلبة مثل الثعلبة المنتشرة والثعلبة الأندروجينية.',
        'يقدم المعالج نصيحة بناءً على فحص المسح والمقابلة الأولية لأفضل علاج مناسب لحالتك.'
      ] : [
        'Bij zowel Peptides Hair Therapy (behandeling 1) als Hair Filler Therapy (behandeling 3) maken wij gebruik van biomimetische peptiden. Het verschil zit in de toevoegingen bij Hair Filler Therapy, zoals hyaluronzuur en ijzer, die zorgen voor intensieve hydratatie en veerkracht van de hoofdhuid.',
        'Dit bevordert de werking van de peptides en fungeert als een krachtige booster tegen haaruitval, vooral bij stress en hormonale wisselingen.',
        'Bij Exosome Hair Therapy (behandeling 2) ligt de nadruk op exosomen. Deze innovatieve ingrediënten verminderen en vertragen haaruitval en kunnen deze zelfs stoppen bij alopecia gerelateerde problemen zoals Alopecia diffusa en Alopecia androgenetica.',
        'De behandelaar geeft aan de hand van het scan onderzoek en intakegesprek een advies voor de beste behandeling, afgestemd op jouw situatie.'
      ]
    },
    careInstructions: [
      {
        title: isArabic ? 'قبل العلاج' : 'Voor de behandeling',
        description: isArabic 
          ? 'للحصول على أنظف الظروف الممكنة (لا يمكن تعقيم الشعر)، يجب غسل الشعر قبل العلاج وعدم استخدام منتجات التصفيف في الشعر.'
          : 'Om de omstandigheden zo schoon mogelijk te krijgen (haar kan je niet ontsmetten), moet je voor de behandeling je haar wassen en geen stylingproducten in je haar aanbrengen.'
      },
      {
        title: isArabic ? 'تدابير الوقاية' : 'Voorzorgsmaatregel',
        description: isArabic 
          ? '• لا تتعرض للشمس أو حمامات الشمس الاصطناعية ولا تشرب الكحول لمدة 24 ساعة قبل العلاج.<br/>• من المهم عدم تناول مسكنات الألم المسيلة للدم مثل الأسبرين والإيبوبروفين لبضعة أيام قبل العلاج.<br/>• إذا كنت تريد تناول مسكن للألم، اختر الباراسيتامول.<br/>• أخيرًا، ننصح بالتوقف عن تناول مكملات أوميغا 3 (زيت السمك) لمدة أسبوع قبل العلاج.'
          : '• 24 uur voor de behandeling niet zonnen, geen zonnebank en geen alcohol nuttigen.<br/>• Belangrijk is om een paar dagen voor een behandeling geen bloedverdunnende pijnstillers zoals aspirine en ibuprofen in te nemen.<br/>• Wil je wel een pijnstiller innemen kies dan voor paracetamol.<br/>• Tot slot adviseren we je om een week voor de behandeling te stoppen met Omega 3 (visolie) supplementen.'
      },
      {
        title: isArabic ? 'العلاج بالضوء LED' : 'LED Lichttherapie',
        description: isArabic 
          ? 'يمكنك إنهاء علاج الميزو للشعر بعلاج LED. مع علاج LED يتم تحفيز الميتوكوندريا في خلايا بصيلات الشعر. الميتوكوندريا هي المصانع الصغيرة في الخلايا التي توفر الطاقة. لذلك يوفر علاج LED دفعة إضافية تحفز نمو الشعر بشكل أفضل.'
          : 'U kunt een meso-hair behandeling afsluiten met een LED therapie behandeling. Met LED therapie worden de mitochondriën in de haarfollikel cellen gestimuleerd. Mitochondriën zijn de fabriekjes in cellen zie voor de energie voorziening zorgen. De LED therapie zorgt dus voor een extra boost wat de haargroei nog beter stimuleert plan opstellen.'
      },
      {
        title: isArabic ? 'الرعاية اللاحقة والفترات الزمنية' : 'Nazorg en interval',
        description: isArabic 
          ? '• لا تستخدم منتجات التصفيف لمدة 24 ساعة بعد علاج فروة الرأس. يجب ترك فروة الرأس في راحة قدر الإمكان.<br/>• تجنب التعرض المباشر لأشعة الشمس لمدة أسبوعين بعد العلاج، وارتد قبعة عند الأنشطة الخارجية إذا لزم الأمر.<br/>• تجنب الساونا لمدة ثلاثة أيام بعد العلاج ولا تأخذ دشًا ساخنًا جدًا.<br/>• المضاعفات الطفيفة المحتملة التي قد تحدث هي الاحمرار والتهيج الخفيف.'
          : '• Gedurende 24 uur geen gebruik maken van styling producten na een scalp behandeling. De hoofdhuid moet namelijk zoveel mogelijk met rust gelaten worden.<br/>• Vermijd 2 weken na de behandeling zo veel mogelijk contact met direct zonlicht, bij buiten activiteiten eventueel een cap dragen.<br/>• Bezoek gedurende drie dagen na de behandeling geen sauna en neem geen heel hete douche.<br/>• Eventuele kleine complicaties die kunnen voorkomen zijn roodheid en lichte irritatie.'
      },
      {
        title: isArabic ? 'الفترة الزمنية' : 'Interval',
        description: isArabic 
          ? 'كل أسبوعين، اعتمادًا على نوع مشكلة فروة الرأس، سينصح أخصائي البشرة بعلاج ووضع خطة علاجية.'
          : '2 weken afhankelijk van het soort hoofdhuidprobleem, zal je huidspecialist een behandeling adviseren en een behandelplan opstellen.'
      }
    ]
  };

  return (
    <section className="treatment-details-section">
      <div className="treatment-details-container">
        <h2 className="section-title">{isArabic ? 'علاج حشو الشعر' : 'Hair Filler Therapy'}</h2>
        
        {/* Treatment Differences */}
        <div className="treatment-details-differences">
          <h3 className="treatment-details-subsection-title">{content.treatmentDifferences.title}</h3>
          <div className="treatment-details-differences-content">
            {content.treatmentDifferences.content.map((paragraph, index) => (
              <p key={index} className="treatment-details-difference-paragraph">
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Care Instructions */}
        <div className="treatment-details-care-instructions">
          <motion.div 
            className="faq-container"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {content.careInstructions.map((instruction, index) => (
              <motion.div 
                key={index} 
                className="faq-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleAccordion(index)}
                >
                  <span>{instruction.title}</span>
                  {openAccordion === index ? <Remove size={20} /> : <Add size={20} />}
                </button>
                <AnimatePresence>
                  {openAccordion === index && (
                    <motion.div 
                      className="faq-answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div 
                        className="care-description"
                        dangerouslySetInnerHTML={{ __html: instruction.description }}
                      />
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentDetailsSection;
